module.exports = __webpack_public_path__ + "static/letters2-eea77d7b8dbde3949334ec670699c308.png";